jQuery(document).on('ready', function () {
	// Check if component is added to the page
	if (jQuery('section.title-slider').length) {
		jQuery('section.title-slider .tiny-slider').each(function () {
			var sliderId = jQuery(this).data('slider');
			window[sliderId] = tns({
				container: 'section.title-slider .tiny-slider[data-slider=' + sliderId + ']',
				items: 1,
				slideBy: 'page',
				mouseDrag: true,
				controls: false,
				nav: true,
// autoplay: true,
				speed: 300, // animation duration
				autoplayTimeout: 6000, // pause duration
				autoplayButtonOutput: false,
				lazyload: true,
			});
		});

		// Play / pause slider
		jQuery('section.title-slider').on('click', function (e) {
			var sliderContainer = jQuery(this);
			var slider = jQuery(this).find('.tiny-slider').data('slider');
			if (sliderContainer.hasClass('paused')) {
				window[slider].play();
				sliderContainer.removeClass('paused');
				return true;
			} else {
				window[slider].pause();
				sliderContainer.addClass('paused');
				return true;
			}
		});
	}

	// Special button action | Simulate click on an element
	jQuery('section.title-slider').on('click', '.button.simulate-click', function(e) {
		e.preventDefault();
		var targetElement = jQuery(this).attr('data-special-action-target');
		jQuery(targetElement).trigger('click');
	});

	// Special button action | Simulate section arrow functionality
	jQuery('section.title-slider').on('click', '.button.simulate-arrow', function(e) {
		e.preventDefault();
		jQuery(this).parents('.components').find('.jump-next-section').first().trigger('click');
	});

    recalculateVh();
	repositionTinySliderNav();
});

jQuery(window).on('load resize', function() {
    recalculateVh();
	repositionTinySliderNav();
});

function recalculateVh() {
    let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
}

function repositionTinySliderNav() {
	jQuery('section.title-slider .tiny-slider').each(function () {
		var slider = jQuery('section.title-slider .tiny-slider[data-slider=' + jQuery(this).data('slider') + ']');
		var headerHeight = jQuery('header').outerHeight();
		var biggestHeightImgVideo = 0;
		slider.find('.tiny-slider-slide .img-video-container').each(function () {
			if( jQuery(this).outerHeight() > biggestHeightImgVideo ) {
				biggestHeightImgVideo = jQuery(this).outerHeight();
			}
		});
		slider.parents('.tns-outer').find('.tns-nav').css({ 'top':(headerHeight + biggestHeightImgVideo - 25)+'px', 'opacity':1 });
	});
}